__turbopack_context__.v({
  "cardBody": "CardBody-module__nPQo-a__cardBody",
});
